
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
name: "",
props: [""],
data() {
return {
apiurl: "",
loading: false,
warningTimes: 0,
};
},
components: { Loading, Toast, Checker, CheckerItem },
created() {},

beforeMount() {},

mounted() {
this.$http.get("./static/api/api.json").then(response => {
this.apiurl = response.api;
this.myUrl = location.href.split("#")[0];
this.getUserinfo();
});
},
methods: {

getUserinfo() {
let _this = this;
this.$http.get(this.apiurl + "/web/member/info").then(res => {
if (res.code === 0) {
_this.warningTimes = res.data.warningTimes;
}
});
},
goRecharge(){
this.$router.push({
name: "recharge",
});
},
goOrderList(){
this.$router.push({
name: "order",
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/wallet.vue